import { jsx } from "react/jsx-runtime";
import { IconButton } from "../../IconButton/IconButton.js";
import { useResponsive } from "../../ResponsiveWrapper/index.js";
function SubmitButton({ handleSubmit, disabled, slots = {
    buttonSlot: ''
}, glass = false }) {
    const { md } = useResponsive();
    const size = md ? 'md' : 'sm';
    return /*#__PURE__*/ jsx(IconButton, {
        iconName: "arrow_upward",
        size: size,
        type: glass ? 'radialPrimary' : 'primary',
        onClick: handleSubmit,
        disabled: disabled,
        slots: {
            buttonSlot: slots?.buttonSlot
        }
    });
}
export { SubmitButton };
